import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { AccessItem, AccessMode, ExtraInfoCodes, ExtraInfoWireFormat } from 'app/components/access-panel/shared/types';
import { PersonActionType } from 'app/area/administration/shared/types';
import { getConfiguration } from './configuration';

export const serializeExtraInfo = (
  item: AccessItem,
  actionType: PersonActionType,
  extraInfoCodes: ExtraInfoCodes,
  originalItem: ExtraInfoWireFormat[]
) => {

  if (item?.mode === AccessMode.role) {
    return [];
  }

  const enabledExtraInfoIds = extraInfoCodes?.values
    ?.map(value => value?.id)
    ?.filter(isDefinedIncludingZero) ?? [];

  const disabledExtraInfo = actionType !== PersonActionType.duplicate
    ? originalItem
      ?.filter(extraInfo => !enabledExtraInfoIds.includes(extraInfo?.extraInfo?.v)) ?? []
    : [];

  if (!item?.customData?.extraInfo) {
    return disabledExtraInfo;
  }

  return [
    ...item.customData.extraInfo
      .map(v => {
        const values = getConfiguration(v.datatype).toWireMapping(v.value);
        return values ?
          values.map(value => ({
            extraInfo: { v: v.fieldId },
            ...value
          }))
          : [];
      })
      .reduce((flat, next) => [...flat, ...next])
      .filter(v => v !== undefined),
    ...disabledExtraInfo
  ];
};
